var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.37133 18.9995H16.3242C16.8765 18.9995 17.3242 18.5518 17.3242 17.9995V11.0725C17.3242 10.5644 17.7361 10.1525 18.2443 10.1525C19.0875 10.1525 19.4865 9.11263 18.8597 8.54856L10.252 0.801627C9.87174 0.459353 9.29442 0.459354 8.91412 0.801628L0.306417 8.54856C-0.320332 9.11263 0.0786894 10.1525 0.921894 10.1525C1.43002 10.1525 1.84194 10.5644 1.84194 11.0725V17.9995C1.84194 18.5518 2.28965 18.9995 2.84194 18.9995H7.37133ZM8.3455 8.25655H10.8206V10.7302H13.2959L13.2959 13.2053H10.8206V15.682H8.3455V13.2053H5.87047V10.7302H8.3455V8.25655Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/iconHome.34bd2e8149107d90c73de43b46a48e4b.svg";
export { ForwardRef as ReactComponent };